import { appAuthenticator } from '@futrli/shared-services';
import { PROMISE_REQUEST } from '@futrli/shared-services';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { DispatchAny, StoreState } from '../../core/types';
import { USERNAME_STORAGE_KEY } from '../../storage/constants';
import { Storage } from '../../storage/storage';
import { FORGOT_PASSWORD, FORGOT_PASSWORD_SENT_PATH } from '../constants';
import { NavigateFunction } from 'react-router-dom';

/**
 * Action to redirect and user to the forgot password page.
 * @param {History} history - allows redirect to the correct path of the app
 * @param {string} username
 * @returns {ThunkDispatch<StoreState, unknown, Action>} thunk dispatch function
 */
export const forgotPassword = (navigate: NavigateFunction, username = ''): DispatchAny => {
  return async (dispatch: ThunkDispatch<StoreState, unknown, Action>) => {
    /* eslint-disable-next-line @typescript-eslint/await-thenable */
    await dispatch({
      type: FORGOT_PASSWORD.ACTION,
      payload: appAuthenticator.forgotPassword(username),
      meta: {
        flag: PROMISE_REQUEST
      }
    });

    Storage.getInstance().set(USERNAME_STORAGE_KEY, username);
    navigate(FORGOT_PASSWORD_SENT_PATH);
  };
};
